var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0026 1.33203C4.3266 1.33203 1.33594 4.3227 1.33594 7.9987C1.33594 11.6747 4.3266 14.6654 8.0026 14.6654C11.6786 14.6654 14.6693 11.6747 14.6693 7.9987C14.6693 4.3227 11.6786 1.33203 8.0026 1.33203ZM8.0026 13.332C5.06194 13.332 2.66927 10.9394 2.66927 7.9987C2.66927 5.05803 5.06194 2.66536 8.0026 2.66536C10.9433 2.66536 13.3359 5.05803 13.3359 7.9987C13.3359 10.9394 10.9433 13.332 8.0026 13.332Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6615 9.05668L5.12883 7.52668L4.1875 8.47068L6.66283 10.9407L11.1335 6.47001L10.1908 5.52734L6.6615 9.05668Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkVerified);
export default __webpack_public_path__ + "static/media/markVerified.a697ff4e4b6756c88e7b9b4bf75edab3.svg";
export { ForwardRef as ReactComponent };